import ChangeCoverServicesMock from './ChangeCoverServicesMock';
import ChangeCoverServices from './ChangeCoverServices';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? ChangeCoverServicesMock : ChangeCoverServices;
